import { createContext, useContext, useState } from "react";
import type { FormProductType } from "../types/product/product.form";

type ProductFormContextType = {
  product: FormProductType;
  setProduct: React.Dispatch<React.SetStateAction<FormProductType>>;
  resetForm: () => void;
  selectedCategory: string;
  setSelectedCategory: React.Dispatch<React.SetStateAction<string>>;
};

const defaultProduct: FormProductType = {
  product: {
    name: "",
    categoryId: "",
    brandId: "",
    description: "",
    descriptionImages: [],
    images: [],
    video: null,
    specs: [],
    isActive: true,
    seo: {
      title: "",
      description: "",
      keywords: [],
      ogImage: {
        url: "",
        public_id: "",
      },
    },
  },
  variants: [],
};

const ProductFormContext = createContext<ProductFormContextType | null>(null);

export const ProductFormProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [product, setProduct] = useState<FormProductType>(defaultProduct);
  const [selectedCategory, setSelectedCategory] = useState<string>("");

  const resetForm = () => {
    setProduct(defaultProduct);
  };

  return (
    <ProductFormContext.Provider
      value={{
        product,
        setProduct,
        resetForm,
        selectedCategory,
        setSelectedCategory,
      }}
    >
      {children}
    </ProductFormContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useProductForm = () => {
  const context = useContext(ProductFormContext);

  if (!context) {
    throw new Error("useProductForm must be used inside ProductFormProvider");
  }
  return context;
};
